import React from "react";
import { Text } from "@mantine/core";
import { useStyles } from "../../../styles/styles";
import { getIconForLabel, getLabelStyle } from "@/pages/ClientProfile/utils";
import type { ContentItem } from "@/pages/ClientProfile/types";

type LabelItemProps = {
  item: ContentItem & { type: "label" };
};

const LabelItem: React.FC<LabelItemProps> = ({ item }) => {
  const { classes } = useStyles();
  const { backgroundColor, fontWeight } = getLabelStyle(item.level);

  return (
    <div className={classes.label} style={{ backgroundColor }}>
      {getIconForLabel(item.text)}
      <Text fw={fontWeight}>{item.text}</Text>
    </div>
  );
};

export default LabelItem;
